module.exports = __webpack_public_path__ + "static/scale-model-of-fort-wool-in-hampton-virginia-489450fa04634b3ac1402d8bc3cae9f2.png";